import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import SubscribeMemberEvent from './SubscribeMemberEvent'

class ParselSubscribeMemberEvent extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={SubscribeMemberEvent} {...props}/>
   )
 }
}



export default ParselSubscribeMemberEvent;
